import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h2>Please checkout </h2>
        </div>
    );
};

export default Checkout;